import React,{useState,useEffect} from 'react';
import { getBusiness } from '../Services/business.service';
import axios from "axios";
import { Link,useLocation,NavLink,useParams } from 'react-router-dom';
import DisplayStarIcons from '../Utils/DisplayStarIcons';
import StarRatings from 'react-star-ratings';
// import profilePic from '../assets/images/profile1.jpg'
// import ReactSearchBox from "react-search-box";
const WriteReviewFunctionalSearch=()=> {
  const [businessFound,setbusinessFound] = useState();
  const [businesStatus,setbusinesStatus] = useState('finding business')
  const [businesIs,setbusinesIs] = useState({});
  const {id} = useParams();
  useEffect(() => {
    const fetchPost=() =>{
      getBusiness().then((res)=>{
      for(let i=0;i<res.length;i++)
      {
        if(res[i].name.toLowerCase() === id.toLowerCase())
        {
          setbusinessFound(true);
        
          setbusinesIs(res[i]);
      
           break;  
        }
        else{
          if((res[i].name.toLowerCase() !== id.toLowerCase())&&((i+1)===res.length))
          {
            // alert('business not found');
            setbusinesStatus('business is not found');
          }
        }
        // else{
        //   setbusinessFound(false);
        // }
      }
    });
    }
    fetchPost();
    console.log(businesIs);
  }, []);
  return (
    <div className='container-fluid m-0 p-0'>
      
       
      
        <div className='row m-0 p-0'>
          
        
           <div className='col-12 m-0 px-4 p-0'>
            <div className='row mb-2 m-0 p-0'>
              {/* Show Component */}
              <div className='col-12 m-0 pt-5 p-0'>
             
              {  
                businessFound?
                
                <div className="row most-review m-0 pt-5 p-0 mb-4 p-5 d-flex justify-content-center align-items-center">
                {console.log('filter business is : ',businesIs)}
                 <div className='col-lg-4 col-md-6 mt-5 mb-3'>
                 <NavLink className="businessCard" to="/discription">
                    <div className='imgDiv'>
                       <img src={businesIs.coverPhotoURL} alt=""></img>
                       <div className='textDiv'>
                           <h4 className='mb-3'>{businesIs.name}</h4>
                           <div><address>{businesIs.address}{businesIs.city}</address></div>
                           <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{businesIs.phoneNumber}</div>
                       </div>
                    </div>
                    <div className="ratingDiv">
                    <div className=''>
                    <StarRatings
                    rating={businesIs.businessCount}
                    starDimension="18px"
                    starSpacing='1px'
                    numberOfStars={5}
                    starRatedColor="orange"
                    >
                    </StarRatings>
                    </div>
                    <div className='profileDiv'>
                      <img src={businesIs.logoURL} alt="logo"></img>
                    </div>
           
                   </div>
                 </NavLink>
                 </div>  
                </div>
                
                :<div className='d-flex justify-content-center align-items-center pt-5' style={{minHeight:'85vh'}}><h1 className='mt-5'>{businesStatus}</h1></div>
              }

              </div>
            </div>
           </div>
        </div>
      
    </div>
  )
}

export default WriteReviewFunctionalSearch
const NonfilterData=(props)=>{
  const [realBusinesses,setrealBusinesses] = useState();
 
  useEffect(() => {
    console.log(props.businessName);
    const fetchPost=() =>{
      getBusiness().then((res)=>{
      for(let i=0;i<res.length;i++)
      {
        if(res[i].name.toLowerCase() === props.businessName.toLowerCase())
        {
          //setbusinessFound(true);
          setrealBusinesses(res[i]);
          break;  
        }
      }
    });
    }
    fetchPost()
  }, []);

   return(
    <div className="row most-review mb-4 p-5">
    
     {console.log('business is : ',realBusinesses)}

        <div className="col-lg-4 col-md-6 mb-3">    
          <NavLink className="businessCard" to="/description">
          
          <div className="imgDiv">
              <img src={realBusinesses.coverPhotoURL} alt="" />
              <div className="textDiv">
                  <h4 className="mb-3">{realBusinesses.name}</h4>
                  <div><address>{realBusinesses.address}{realBusinesses.city}</address></div>
                  <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{realBusinesses.phoneNumber}</div>
              </div>
          </div>
          <div className="ratingDiv">
              <div className="">
              <StarRatings
              rating={realBusinesses.businessCount%5}
              starDimension="18px"
              starSpacing="1px"
              numberOfStars={5}
              starRatedColor="orange"
          />
              </div>
              <div className="profileDiv"><img src={realBusinesses.logoURL} alt="logo" /></div>
          </div>
          </NavLink>
        </div>
    
    
</div>
    
   )
}







{/* <div className="row most-review mb-4 p-5">
    
{console.log('business is : ',realBusinesses)}

   <div className="col-lg-4 col-md-6 mb-3">    
     <NavLink className="businessCard" to="/description">
     
     <div className="imgDiv">
         <img src={realBusinesses.coverPhotoURL} alt="" />
         <div className="textDiv">
             <h4 className="mb-3">{realBusinesses.name}</h4>
             <div><address>{realBusinesses.address}{realBusinesses.city}</address></div>
             <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{realBusinesses.phoneNumber}</div>
         </div>
     </div>
     <div className="ratingDiv">
         <div className="">
         <StarRatings
         rating={realBusinesses.businessCount%5}
         starDimension="18px"
         starSpacing="1px"
         numberOfStars={5}
         starRatedColor="orange"
     />
         </div>
         <div className="profileDiv"><img src={realBusinesses.logoURL} alt="logo" /></div>
     </div>
     </NavLink>
   </div>


</div> */}







{/* <div className="row most-review mb-4 p-5">
{
  realBusinesses&&realBusinesses.map((item,index)=>(

    <div className="col-lg-4 col-md-6 mb-3" key={index}>    
      <NavLink className="businessCard" to="/description">
      <div className="imgDiv">
        {console.log(item)}
          <img src={item.coverPhotoURL} alt="" />
          <div className="textDiv">
              <h4 className="mb-3">{item.name}</h4>
              <div><address>{item.address}{item.city}</address></div>
              <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{item.phoneNumber}</div>
          </div>
      </div>
      <div className="ratingDiv">
          <div className="">
          <StarRatings
          rating={item.businessCount%5}
          starDimension="18px"
          starSpacing="1px"
          numberOfStars={5}
          starRatedColor="orange"
      />
          </div>
          <div className="profileDiv"><img src={item.logoURL} alt="logo" /></div>
      </div>
      </NavLink>
    </div>
    ))
}
</div> */}















// const FilterData=(props)=>{
//   const [filterType,setFilterType] = useState();
//   const [filterArray,setfilterArray] = useState();
//   const [customItemIndex,setcustomItemIndex] = useState();
//   useEffect(()=>{
//     ///alert('filter type fom the parent is ',props.filterType)
//     let temp ={};
//     switch (props.filterType) {
//         case "star-high":
//        // setfilterName(e.target.value);
//         console.log("Sort the High to low : " ,props.filterData);
//         for (let i=0; i<props.filterData.length-1;i++){
//             for(let j=i+1;j<props.filterData.length;j++)
//             {
//               if((props.filterData[i].businessCount)<(props.filterData[j].businessCount))
//                 {temp = props.filterData[i];
//                 props.filterData[i]=props.filterData[j];
//                 props.filterData[j]=temp;
//                 }
//             }
//         }
//         //setFilterType(props.filterType);
//         setfilterArray(props.filterData);
//         console.log('Sorted Data is : ',props.filterData)
//         break;
//         case "star-low":
//           console.log("Sort the low to High : " ,props.filterData);
//           for (let i=0; i<props.filterData.length-1;i++){
//             for(let j=i+1;j<props.filterData.length;j++)
//             {
//               if((props.filterData[i].businessCount)>(props.filterData[j].businessCount))
//                 {temp = props.filterData[i];
//                 props.filterData[i]=props.filterData[j];
//                 props.filterData[j]=temp;
//                 }
//             }
//         }
//         setFilterType(props.filterType);
//         setfilterArray(props.filterData);
//         //setfilterName(e.target.value);
//         break;
//         case "star-company":
//           props.filterData.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
//           console.log('Filter By business name',props.filterData);
//           setFilterType(props.filterType);
//           setfilterArray(props.filterData);
//         break;
//       default:
//         for(let i=0;i<filterArray.length;i++){
//           console.log(i);
//            if(props.filterData[i].name===props.filterType){
//              console.log('it will wor when none of the case is working',filterArray[i].name);
//              setFilterType('custom');
//              setcustomItemIndex(i);
//              break;
//            }
//            if(i+1==filterArray.length)
//            {
//             setFilterType('Buniness not found');
//            }
//         }
//       break;
//     }
//     //console.log('Making concept clear :',props.filterType);
//     //console.log('Making concept clear :',props.filterData,' finally get worked');
//   },[props.filterType])
//   return(
//     <>
//     {
//      (typeof filterArray === "undefined")?
//       <h1>Some thing went wrong while fetching data from firebase</h1>:
//       filterType!=='custom'?
//       <div className='container-fluid m-0 p-3'>
//       {
//         filterArray&&filterArray.map((item,index)=>
//         <div className='row mb-4 m-0 p-0' key={index}>
//        <div className='col-8 m-0 p-0 d-flex'>
//            <div className="reviewPageListImg mx-2">
//             <img src={item.coverPhotoURL} alt="profilePic" />
//            </div>
//            <div>
//        <p className="mb-1" style={{fontWeight:'bold'}}>{item.name} </p>
//        <p className="mb-0">Address: {item.address}</p>

//        <span>Phone: {item.phoneNumber} </span>
//        <div> Current Rating : {DisplayStarIcons(item.businessCount)}</div>
//        <div className="tag">
//        </div>                      
//        </div>
//        </div>
//        <div className='col-4 m-0 p-0 d-flex justify-content-center align-items-center'>
//            <div className="write-review border rounded-pill">  
//            {
//              console.log('Business Id before sending to review ',item.businessId)
//            }
//             <Link className="btn buttons reviewPage-WriteBtn w-100 fs-5 p-0" to={`/company-rate/${item.businessId}`}>Write Review</Link>                                             
//             </div>
//        </div>
//        </div>)
//       }
//     </div>:filterType==='Buniness not found'?<h1>No record found</h1>:
//     <div className='container-fluid m-0 p-3'>
//     <div className='row mb-4 m-0 p-0'>
//     <div className='col-8 m-0 p-0 d-flex'>
//        <div className="reviewPageListImg mx-2">
//         <img src={filterArray[customItemIndex].coverPhotoURL} alt="profilePic" />
//        </div>
//        <div>
//     <p className="mb-1" style={{fontWeight:'bold'}}>Business Name {filterArray[customItemIndex].name} </p>
//     <p className="mb-0">Address: {filterArray[customItemIndex].address}</p>
    
//     <span>Phone: {filterArray[customItemIndex].phoneNumber} </span>
//     <div> Current Rating : {DisplayStarIcons(filterArray[customItemIndex].businessCount)}</div>
//     <div className="tag">
//     </div>                      
//     </div>
//     </div>
//     <div className='col-4 m-0 p-0 d-flex justify-content-center align-items-center'>
//        <div className="write-review border rounded-pill">  
//         <Link className="btn buttons reviewPage-WriteBtn w-100 fs-5 p-0" to={{pathname:`/rate-company/${filterArray[customItemIndex].businessId}`}}>Write Review</Link>                                             
//         </div>
//     </div>
//     </div>
//     </div> 
//    }
//     </>
//   )
// }
